"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleSerializer = void 0;
var dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
var models_1 = require("../../models");
var RoleSerializer = /** @class */ (function () {
    function RoleSerializer() {
    }
    RoleSerializer.prototype.serialize = function (roleDto) {
        var _a;
        return new models_1.Role({
            activeRole: roleDto.activeRole,
            availableRoles: (_a = roleDto.availableRoles) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x !== dp_acma_dawn_sdk_1.CognitoRole.STUDENT; }),
        });
    };
    return RoleSerializer;
}());
exports.RoleSerializer = RoleSerializer;
